/**
 * ダイアログ用データリセット処理
 * マスタダイアログを閉じる時に入力データをリセット
 */
export const useResetData = () => {
  /**
   * @param initializeData - initializeData from useMasterDialog
   * @param defaultData - optional
   */
  const resetMasterData = (
    initializeData: (config: {
      initialData: null
      defaultData: Record<string, unknown>
      isAdd: boolean
    }) => void,
    defaultData: Record<string, unknown> = { data: null }
  ) => {
    initializeData({
      initialData: null,
      defaultData,
      isAdd: true
    })
  }

  return {
    resetMasterData
  }
}
